import { render, staticRenderFns } from "./SubjectInfo.vue?vue&type=template&id=30778dc8&scoped=true"
import script from "./SubjectInfo.vue?vue&type=script&lang=js"
export * from "./SubjectInfo.vue?vue&type=script&lang=js"
import style0 from "./SubjectInfo.vue?vue&type=style&index=0&id=30778dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30778dc8",
  null
  
)

export default component.exports